import React, { useState } from 'react';
import Modal from 'react-modal';
import { toast } from 'react-toastify';
import { forgotPasswordIntermediary } from '../../utils/api';
import { notifyPassword } from '../../utils/notify';
import './PasswordIntermediary.css';

Modal.setAppElement('#root');

function PasswordIntermediary({ isOpen, closeModal }) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const validationEmail = () => {
    const charactersEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!charactersEmail.test(email)) {
      notifyPassword('Por favor, insira um endereço de e-mail válido.');
      return false;
    }

    return true;
  };

  const handleResetPassword = async (event) => {
    event.preventDefault();

    if (!validationEmail()) {
      return;
    }

    setLoading(true);
    const toastId = toast.loading('Enviando solicitação...');

    try {
      const response = await forgotPasswordIntermediary({ email: email.trim() });
      const responseData = await response.json().catch(() => ({}));

      if (!response.ok) {
        toast.update(toastId, {
          render: responseData.error || 'Erro ao processar a solicitação.',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        });
        return;
      }

      toast.update(toastId, {
        render: responseData.message || 'Se o e-mail estiver cadastrado, enviaremos uma senha temporária em instantes.',
        type: 'success',
        isLoading: false,
        autoClose: 3000,
      });
      setEmail('');
      closeModal();
    } catch (error) {
      toast.update(toastId, {
        render: 'Erro interno ao processar a solicitação.',
        type: 'error',
        isLoading: false,
        autoClose: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel="Recuperar senha da intermediação"
      className='absolute inset-10 h-sm:inset-0 border-gray-300 bg-white overflow-auto outline-none p-5 rounded-2xl w-1/3 h-sm:w-full mx-auto mt-20'
      shouldCloseOnOverlayClick={true}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1000,
        },
        content: {
          zIndex: 1001,
          height: '400px',
          backgroundColor: '#004e80'
        },
      }}
    >
      <div className='w-full h-auto flex justify-end'>
        <button type='button' className='rounded-full h-9 w-9 text-white font-bold' onClick={closeModal} style={{ border: '4px solid white' }}>X</button>
      </div>
      <form className='text-center px-10 space-y-4 h-sm:px-5' onSubmit={handleResetPassword}>
        <h1 className='text-white text-2xl mb-5'>Esqueceu sua senha?</h1>
        <div className='pb-5'>
          <span className='text-white text-base'>
            Será enviado um e-mail para sua conta com as instruções para redefinir sua senha de forma segura.
          </span>
          <br />
          <span className='text-white text-base'>Depois, basta realizar o login novamente.</span>
        </div>
        <input
          type='email'
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          placeholder='Email'
          className='w-full bg-slate-200 rounded-lg h-10 p-3 font-normal'
          id='intermediary_new_password'
          name='intermediary_new_password'
          disabled={loading}
          required
        />
        <button type='submit' className='text-white rounded-lg border-0 w-full h-10 text-base cursor-pointer' style={{ backgroundColor: '#c76f36' }} disabled={loading}>
          {loading ? 'Enviando...' : 'Redefinir'}
        </button>
        <button type='button' className='intermediary-return-to-login' onClick={closeModal} disabled={loading}>Voltar ao login</button>
      </form>
    </Modal>
  );
}

export default PasswordIntermediary;
